import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import QueryFilterFieldAddCell from '../containers/QueryFilterFieldAddCell';
import { cohortFilterWidths } from '../constants';

const QueryFilterAddRow = ({
  className,
  category,
  code,
  dictionaryCode,
  clauseUUID,
  queryUUID,
  filterUUID,
  first,
}) => (
  <Table.Row className={clsx('aridhia-query-filter-row', className)} verticalAlign="top">
    <Table.Cell collapsing />
    <QueryFilterFieldAddCell
      code={code}
      category={category}
      dictionaryCode={dictionaryCode}
      queryUUID={queryUUID}
      clauseUUID={clauseUUID}
      filterUUID={filterUUID}
    />
    {first && (
      <>
        <Table.Cell width={cohortFilterWidths.OPERATOR} />
        <Table.Cell width={cohortFilterWidths.VALUES} />
        <Table.Cell collapsing />
        <Table.Cell collapsing />
      </>
    )}
  </Table.Row>
);

export default QueryFilterAddRow;
